import { Col, Empty, List, Row, Typography } from "antd";
import { useIntl } from "react-intl";
import { StyledEarningGraphWrapper } from "./index.styled";
import AppCard, { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import ListItem from "./ListItem";
import Graph1 from "./Graphs/Graph1";
import Graph2 from "./Graphs/Graph2";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

export type PieChartData = {
  name: string;
  value: number;
  valueText?: string | JSX.Element;
  color?: string;
  icon?: string;
};

type Props = {
  title?: string;
  navigate?: () => void;
  loading?: boolean;
  refetch?: () => void;
  data: PieChartData[];
  graph?: "graph1" | "graph2";
  showList?: boolean;
  extra?: string | JSX.Element;
  cardProps?: AppCardProps;
};

export const CustomPieChart = (props: Props) => {
  const {
    data,
    loading,
    title,
    navigate,
    refetch,
    graph = "graph1",
    showList = true,
    extra,
    cardProps,
  } = props;
  const { messages } = useIntl();

  const Graph = () => {
    switch (graph) {
      case "graph1":
        return <Graph1 data={data} loading={loading} />;

      case "graph2":
        return <Graph2 data={data} loading={loading} />;

      default:
        return <Graph1 data={data} loading={loading} />;
    }
  };

  return (
    <AppCard
      title={title}
      heightFull
      {...cardProps}
      extra={
        <StyledFlex style={{ gap: 10 }}>
          {extra}
          <>
            {navigate && (
              <Typography.Link onClick={() => navigate()}>
                {messages["common.viewAll"] as string}
              </Typography.Link>
            )}
          </>
          {refetch && (
            <ActionButton
              type="refresh"
              size="small"
              onClick={() => refetch()}
              disabled={loading}
              loading={loading}
            />
          )}
        </StyledFlex>
      }
    >
      {data.length == 0 ? (
        <Empty />
      ) : (
        <StyledEarningGraphWrapper>
          <Row>
            <Col xs={12} md={24} xl={24} xxl={12}>
              <div>
                <Graph />
              </div>
            </Col>
            {showList && (
              <Col xs={12} md={24} xl={24} xxl={12}>
                <div className="earning-item">
                  <List loading={loading}>
                    {!loading &&
                      data &&
                      data.map((d) => <ListItem data={d} key={d.name} />)}
                  </List>
                </div>
              </Col>
            )}
          </Row>
        </StyledEarningGraphWrapper>
      )}
    </AppCard>
  );
};

export default CustomPieChart;
